import { resolveTheme } from 'theme/resolveTheme';

/**
 * Fallback store profile used until (or if) GET /public/store answers.
 * Same shape as the API's `value`. It is deliberately generic: no contact
 * details, so the WhatsApp button and contact blocks stay hidden. The theme is
 * the default preset; the shop's own theme replaces it as soon as it loads.
 */
export const DEFAULT_STORE = Object.freeze({
  identity: {
    name: 'Toko',
    tagline: null,
    logoUrl: null,
    faviconUrl: null,
    whatsapp: null,
    email: null,
    phone: null,
    address: { line1: null, city: null, province: null, postalCode: null },
  },
  theme: resolveTheme(null),
  locale: 'id-ID',
  currency: 'IDR',
  timezone: 'Asia/Jakarta',
  pages: null,
  // GET /public/store `checkout`: terms link, e-mail rule, pickup offered.
  checkout: { termsUrl: null, requireEmail: false, pickupEnabled: true, paymentExpiryMinutes: null },
  // GET /public/store `payment`: the payment groups on offer ({ channel, label }); none = unknown.
  payment: { groups: [], bankAccounts: [] },
  // Articles (GET /public/store `articles`): no links until the shop says it has some.
  articles: { enabled: false, show: false },
  // Shop wording from the server (GET /public/store `copy`); null = i18n default.
  copy: { relatedProductsTitle: null },
});
